import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

import ProgressRing from '../ProgessRing/ProgessRing';
import * as styles from './Pips.module.scss';

const Pips = ({
  className,
  count = 1,
  currentIndex = 0,
  orientation = 'horizontal',
  onItemClick,
  showProgress = false,
  progressSpeed,
  step = 1,
  isWhiteOut = false,
}) => {
  const classname = classNames(styles.pips, className, {
    [ styles.isHorizontal ]: orientation === 'horizontal',
    [ styles.isVertical ]: orientation === 'vertical',
    [ styles.isWhiteOut ]: isWhiteOut,
  });
  const [ currentProgress, setProgress ] = useState(0);
  const items = [];
  const Tag = onItemClick ? 'button' : 'span';

  useEffect(() => {
    if (showProgress) {
      const speed = progressSpeed / 100;
      const interval = setInterval(() => {
        setProgress((p) => p + step);
      }, speed * step);

      return () => {
        setProgress(0);
        clearInterval(interval);
      };
    }
  }, [ showProgress, currentIndex, progressSpeed, step ]);

  function handleItemClick(index) {
    if (onItemClick) {
      onItemClick(index);
    }
  }

  for (let i = 1; i <= count; i++) {
    const isActive = currentIndex === i - 1;

    items.push(
      <li className={styles.item} data-active={isActive} key={i}>
        <Tag
          className={styles.button}
          aria-label={isActive ? `${i} (current slide}` : `${i}`}
          onClick={(e) => handleItemClick(i - 1)}
        >
          <svg
            width="40"
            height="40"
            viewport="0 0 100 100"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              className={styles.pip}
              r="4"
              cx="20"
              cy="20"
              fill="transparent"
              strokeDasharray="565.48"
              strokeDashoffset="0"
            />

            {showProgress && isActive && (
              <ProgressRing
                className={styles.bar}
                radius={20}
                stroke={2}
                progress={currentProgress}
              />
            )}
          </svg>
        </Tag>
      </li>
    );
  }

  return <ul className={classname}>{items}</ul>;
};

export default Pips;
